import { range, mergeWith } from 'lodash';
import moment from 'moment/moment';

const TODAY = moment();

export function generateYears(from = TODAY.year() + 6 , to = TODAY.year()) {
  return range(to, from).map(v => v.toString());
}

export function generateDays(year, month) {
  if (!year) {
    year = TODAY.year();
  }
  if (!month) {
    month = TODAY.month();
  }

  let currentDate = moment(year + month, ['YYYYMM']);

  const formatDayNum = day => currentDate.date(day).format('DD');

  return range(1, currentDate.daysInMonth() + 1).map(formatDayNum);
}

export function generateMonths(lang) {
  const months = range(1, 13, 1);

  const monthNames = moment.localeData(lang).months();

  const formatMonth = (v1, v2) => {
    return {
      id: moment(v1, 'MM')
        .format('MM'),
      name: v2
    };
  };

  return mergeWith(months, monthNames, formatMonth);
}
